import React from 'react';
import Button from "components/Buttons/Button";
import LinkButton from "components/Buttons/LinkButton";
import Rodal from 'components/Rodal';
import Icon from 'components/Icon';
import stockImages from 'utils/stockImages';
import styles from 'modules/media/components/StockListModalStyles.scss';
import debounce from 'lodash/debounce';
import {userSelector} from "modules/auth/authSelectors";
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import config from 'config';

const PAGINATION_AMOUNT = 12;

@connect(userSelector, {})
export default class ImageElementModal extends React.Component {
  state = {
    availableTags: [],
    searchTerm: '',
    amountToShow: 12,
    selectedTags: [],
    adding: false,
    //StockImages: [],
  };

  componentDidMount() {
    this.debounceSetFilterText = debounce(this.setFilterText, 500);
  }


  addStockItem = (options) => {
    const {submit, close} = this.props;
    const {src, key} = options;
    const size = this.getSize(key);

    submit({
      src,
      height: size.height,
      width: size.width
    });
    close();
  };

  getSize = (key)=>{
      const id = 'stockimage-'+key;
      const el = document.getElementById(id);
      return {
        height: el.offsetHeight,
        width: el.offsetWidth,
      }
  };

  stockItem = (item, key) => {
    const {user} = this.props;

    return (
      <div key={key} className={styles.listItem}>
        <div className={styles.listItemInner}>
          <div className={styles.imageHolder}>
            <div className={styles.inner}>
              <img src={item.src}  id={'stockimage-'+key}/>
            </div>
          </div>
          <div className={styles.textHolder}>
            <span>{item.name}</span>
            <div className={styles.addButton}>
              {
                (user.is_club || user.evolution_pro) ?
                    <Button primary noMarginRight={true} right={true} small onClick={() => this.addStockItem({src: item.src, key})}>Select</Button> :
                    <LinkButton primary noMarginRight={true} right={true} small to="/upgrade">Upgrade</LinkButton>
              }
            </div>
          </div>
        </div>
      </div>
    );
  };

  getStockListsFilteredBySearchTerm = () => {
    const {searchTerm, selectedTags} = this.state;

    let filteredStockImages = stockImages;

    if(! filteredStockImages.length) {
      return [];
    }

    if (searchTerm.length > 0) {
      filteredStockImages = filteredStockImages.filter((item) => item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
    }

    if (selectedTags.length > 0) {
      filteredStockImages = filteredStockImages.filter((item) => {
        let hasFound = false;
        selectedTags.forEach((tag) => {
          if (item.tags.indexOf(tag) !== -1) {
            hasFound = true;
          }
        });
        return hasFound;
      });
    }

    return filteredStockImages;
  };

  renderStockList = () => {
    const {amountToShow} = this.state;

    let filteredStockVideos = this.getStockListsFilteredBySearchTerm().slice(0, amountToShow);
    return filteredStockVideos.map((item, key) => {
      return this.stockItem(item, key);
    });
  };

  loadMoreStockListItems = () => {
    this.setState({amountToShow: this.state.amountToShow + PAGINATION_AMOUNT})
  };

  setFilterText(value) {
    this.setState({searchTerm: value});
  };

  changeTags = (tags) => {
    this.setState({selectedTags: tags});
  };

  render() {
    const isMore = this.state.amountToShow < this.getStockListsFilteredBySearchTerm().length;
    const {close, showStockList, user} = this.props;

    return (
      <Rodal
        visible={showStockList}
        onClose={close}
        height={675}
        width={1000}
      >
        <div>
          <div className="modal-heading">
            <Icon name="list" /> Image Library
          </div>

          <div className="modal-body">
            <div className={styles.filterWrapper}>
              <div className={styles.filterLeftWrapper}>
                Filter: <input name="filter" className={styles.filterInput} onChange={(e) => this.debounceSetFilterText(e.target.value)} placeholder="Filter by name" />
              </div>
              <div className={styles.filterRightWrapper}>
                {/* May add in image tagging later */}
                {/*Tags:*/}
                {/*<StockListTagsFilter*/}
                  {/*availableTags={this.state.availableTags}*/}
                  {/*onChange={this.changeTags}*/}
                {/*/>*/}
              </div>
            </div>

            <div className={styles.listWrapper}>
              {
                ( user.evolution_pro ||  user.is_club ) ? null :
                  <div style={{textAlign: 'center', display:'block', marginTop:'5px', marginBottom: '5px', width: '100%', backgroundColor: '#f3f3f3', paddingTop: '5px', paddingBottom: '5px'}}>
                    <p>Our Image Library is only available to Evolution Pro users. <Link to="/upgrade">Upgrade Here</Link></p>
                  </div>
              }
              {this.renderStockList()}
              {
                isMore &&
                <div style={{textAlign: 'center', display:'block', marginTop:'20px', marginBottom: '20px', width: '100%'}}>
                  <Button onClick={this.loadMoreStockListItems} noFloat={true}>Load More</Button>
                </div>
              }
            </div>
          </div>

          <div className="modal-footer">
            <Button primary onClick={this.props.close}>
              Close
            </Button>
          </div>
        </div>
      </Rodal>
    )
  }
}
